import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=6040e7a3&"
import script from "./learning.vue?vue&type=script&lang=js&"
export * from "./learning.vue?vue&type=script&lang=js&"
import style0 from "./learning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports